import useDomesticHelperFlow from "../../../../hooks/useDomesticHelperFlowSimple";
import useLanguageTranslate from "../../../../hooks/useLanguageTranslate";
import DomesticHelperBottomStickyBtnLayout from "../../layouts/DomesticHelperBottomStickyBtnLayout";
import DomesticHelperJourneyLayout from "../../layouts/DomesticHelperJourneyLayout";

const ContractDetails = () => {
  const translate = useLanguageTranslate();
  const { handleNextStep, handlePrevSubstep } = useDomesticHelperFlow();

  return (
    <div className="contract-details w-full">
      <DomesticHelperJourneyLayout
        is_hide_back_btn={false}
        customBackHandler={handlePrevSubstep}
      >
        <div className="content min-w-[32%] max767:w-full">
          <h1 className="text-[#1A2024] text-2xl not-italic font-semibold leading-8 tracking-[-0.24px] text-center max767:text-left">
            {translate("Contract Details", "تفاصيل العقد")}
          </h1>
          <p className="text-[#1A2024] text-base not-italic font-normal leading-6 tracking-[-0.16px] text-center mt-1 mb-6 max767:text-left">
            {translate(
              "Employment contract terms and conditions",
              "شروط وأحكام عقد العمل"
            )}
          </p>
        </div>
        <DomesticHelperBottomStickyBtnLayout
          show_summary={false}
          btn_onClick={handleNextStep}
        >
          <div className="w-[32%] max767:w-full mx-auto ipad:w-[60%] p-8 text-center">
            <p className="text-gray-600">
              Contract details form coming soon...
            </p>
            <p className="text-sm text-gray-500 mt-2">
              Start date, duties, working hours, terms
            </p>
          </div>
        </DomesticHelperBottomStickyBtnLayout>
      </DomesticHelperJourneyLayout>
    </div>
  );
};

export default ContractDetails;
